import { Injectable } from '@angular/core'
import { HttpClient } from "@angular/common/http";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { UrlsResources } from "../urls-resources";
import { HandleError } from '../handle-error';
import {ElectronicTransferModel} from "./member-wallet.model";

@Injectable()
export class TransferService {

  constructor(private http: HttpClient,
    private handleError: HandleError,
    private urlsResources: UrlsResources) {
  }

  doElectronicTransferToUsers(electronicTransfer: ElectronicTransferModel) {

    const httpOptions = { withCredentials: true };
    return this.http.post(this.urlsResources.doElectronicTransferToUsers(), electronicTransfer, httpOptions)
      .map(response => { return response; })
      .catch(error => this.handleError.handleErrorAsObservable(error));

  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/transfers/transfers.service.ts